var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExceptionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0808 2.17318C9.98154 1.97119 9.8277 1.80105 9.63669 1.68206C9.44567 1.56307 9.22513 1.5 9.00008 1.5C8.77504 1.5 8.5545 1.56307 8.36348 1.68206C8.17247 1.80105 8.01863 1.97119 7.91941 2.17318L1.60401 15.0387C1.52799 15.1933 1.49263 15.3648 1.50128 15.5369C1.50992 15.709 1.56229 15.876 1.65343 16.0223C1.74456 16.1685 1.87147 16.2891 2.02216 16.3727C2.17285 16.4563 2.34236 16.5001 2.51468 16.5H15.4855C15.6578 16.5001 15.8273 16.4563 15.978 16.3727C16.1287 16.2891 16.2556 16.1685 16.3467 16.0223C16.4379 15.876 16.4902 15.709 16.4989 15.5369C16.5075 15.3648 16.4722 15.1933 16.3962 15.0387L10.0808 2.17318Z",
    fill: "white",
    stroke: "#C44545",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00016 13.0137C8.91283 13.0137 8.82746 13.0396 8.75484 13.0881C8.68222 13.1366 8.62563 13.2056 8.59221 13.2863C8.55878 13.3669 8.55004 13.4557 8.56708 13.5414C8.58412 13.627 8.62617 13.7057 8.68793 13.7675C8.74968 13.8292 8.82836 13.8713 8.91402 13.8883C8.99967 13.9054 9.08846 13.8966 9.16915 13.8632C9.24983 13.8298 9.3188 13.7732 9.36732 13.7006C9.41584 13.628 9.44174 13.5426 9.44174 13.4552C9.44174 13.3381 9.39521 13.2258 9.3124 13.143C9.22959 13.0602 9.11728 13.0137 9.00016 13.0137Z",
    fill: "#C44545",
    stroke: "#C44545",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.9942V5.99414",
    stroke: "#C44545",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExceptionsIcon);
export default __webpack_public_path__ + "static/media/ExceptionsIcon.19f3436a559c2dc0351b3cb9cd21a0a2.svg";
export { ForwardRef as ReactComponent };